import { isFunction } from "./utils";
import axios from "./axios";
export async function addEmailToWaitlist(email, config = {}) {
    const requestConfig = { url: '/waitlist', method: 'post', data: { email } };
    try {
        const res = await axios(requestConfig);
        if (isFunction(config.onSuccess))
            await config.onSuccess(res);
        return res;
    }
    catch (error) {
        if (isFunction(config.onError))
            await config.onError(error);
    }
}
